import React, {useState} from 'react';
import {ChatParticipantItem} from './ChatParticipantItem';
import {v4 as uuid4} from 'uuid';
import {User} from '../../types/users';
import {AddParticipantForm} from './AddParticipantForm';
import {getClaimTypeName} from "../../helpers/claims";
import {ClaimTypes} from "../../types/travelClaims";
import {nounDeclension} from "../../helpers/text";
import {ParticipantsModal, RemoveParticipantModal} from "./ChatParticipantModal";

interface Props {
    participants: User[]
    chat_pk?: string
    trip_id?: string
    comment?: string
    claim_type?: ClaimTypes
}

export const ChatParticipantList = ({participants, chat_pk, trip_id, claim_type, comment}: Props) => {
    const [participantsOpen, setParticipantsOpen] = useState(false);

    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const handleClose = () => {
        setSelectedUser(null);
    }
    const handleOpenParticipants = ()=>{
        setParticipantsOpen(true)
    }
    const handleCloseParticipants = ()=>{
        setParticipantsOpen(false)
    }

    return (
        <div className='flex flex-row justify-between w-full bg-white rounded-t-lg h-22 shadow-below'>
            {/*СВОДКА*/}
            <div
                onClick={handleOpenParticipants}
                className="max-w-[30%] flex px-5 justify-center gap-0.5 flex-col items-center cursor-pointer">
                <div
                    className="
                    relative
                    w-full text-black
                    font-manager-acrom-h3-20-medium-acrom
                    text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)]
                    leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)]
                    font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)]
                    tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)]
                    [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]
                    ">
                    {claim_type ? getClaimTypeName(claim_type) : ''}
                </div>
                <div
                    className="w-full text-[#949494] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {participants.length} {nounDeclension('участник', participants.length)}
                </div>
            </div>

            {/*КОММЕНТАРИЙ*/}
            <div className="max-w-[50%] max-h-22 flex px-5 justify-center overflow-hidden flex-col items-center">
                <div
                    className="truncate w-full text-[#949494] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {comment}
                </div>
            </div>
            {/*УЧАСТНИКИ ЧАТА*/}
            <div className="flex flex-row max-w-[30%] items-center justify-end">
                {/*{chat_pk && trip_id && !!selectedUser && <RemoveParticipantModal*/}
                {/*    isOpen={!!selectedUser}*/}
                {/*    claim_pk={trip_id}*/}
                {/*    chat_pk={chat_pk}*/}
                {/*    onClose={handleClose}*/}
                {/*    user={selectedUser}*/}
                {/*/>}*/}
                {chat_pk && trip_id && <ParticipantsModal
                    isOpen={participantsOpen}
                    claim_pk={trip_id}
                    chat_pk={chat_pk}
                    onClose={handleCloseParticipants}
                    users={participants}
                />}
                <div className='flex flex-row rounded-t-lg gap-1 w-full'>
                    {participants.slice(0, 4).map((participant: User, index) => {
                        return <ChatParticipantItem
                            key={index}
                            user={participant}
                            onClick={handleOpenParticipants}
                        />
                    })}
                    {/*Кол-во участников в остатке*/}
                    {/*{participants.length > 3*/}
                    {/*    ? <div className={`*/}
                    {/*           rounded-full */}
                    {/*           !h-10 !w-10 */}
                    {/*           flex-[0_0_auto] */}
                    {/*           flex justify-center items-center */}
                    {/*           text-black*/}
                    {/*           bg-melon-light-grey*/}
                    {/*           `*/}
                    {/*    }>+{participants.length - 3}</div>*/}
                    {/*    : null*/}
                    {/*}*/}
                </div>
                <div className='flex justify-between rounded-b-lg p-5 '>
                    {chat_pk && trip_id && <AddParticipantForm chat_pk={chat_pk} trip_id={trip_id}/>}
                </div>
            </div>
        </div>
    );
};
